import axios from 'axios';
import { getToken } from '../util';
import { navigateTo } from '../components/AppHeader/Link';
import { PATH_ADMIN_LOGIN } from '../components/path';

axios.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers['Authorization'] = getToken();
        }
        return config;
    },
    err => Promise.reject(err),
);
axios.interceptors.response.use(
    res => {
        const contentType = res.headers['content-type'] || '';
        if (
            contentType.includes('application/vnd.openxmlformats') ||
            contentType.includes('application/octet-stream')
        ) {
            return res;
        }
        return res.data ?? res;
    },
    err => {
        console.error(err);
        if (err.response?.status === 401) {
            navigateTo(PATH_ADMIN_LOGIN);
        }
        return Promise.reject(err);
    },
);

export const setBaseURL = async function () {
    return await axios
        .get(`${window.location.origin}${window.location.pathname.replace(/\/$/, '')}${process.env.API_CONFIG_PATH}`)
        .then(config => {
            if (config && config.apiURL) {
                axios.defaults.baseURL = config.apiURL;
            }
            return config;
        })
        .catch(error => {
            console.error('Failed to set the base URL.', error);
            return error;
        });
};

export const get = (url, param) => axios.get(url, { params: { ...param } });
export const post = axios.post;
export const deleteReq = axios.delete;
